import React from "react";
import { SNavigation, SNotification, SPage, SView } from "servisofts-component2";
import MDL from "../MDL";
import Mapa from "./root/Mapa";
import UserProfile from "./root/UserProfile";
import BottomBoxExpediciones from "./root/BottomBoxExpediciones";
import Recargar from "../Components/Recargar";
import TopBar from '../Components/TopBar/index';

export default class index extends React.Component {
    static TOPBAR = <TopBar type={"home"} />

    constructor(props: any) {
        super(props);
        this.state = {
            ready: false,
            checklistTractoraFaltante: false,
            checklistRemolqueFaltante: false,
        };
    }

    componentDidMount() {

        MDL.usuario.addEventListener("onChangeUser", () => {
            this.loadData();
        });
        if (!MDL.usuario?.session) {
            SNavigation.replace("/login");
            return;
        }
        if(MDL.usuario.session.type == "admin"){
            SNavigation.replace("/admin");
            return;
        }
        this.loadData();
        this.setState({ ready: true });


    }
    async loadData() {
        this.forceUpdate();
        MDL.sigestran.getExpediciones().catch(e => {
            console.error("Error al obtener expediciones", e);
        })
        this.verificarChecklist();
    }

    verificarChecklist = async () => {
        try {
            const matriculas = await MDL.checklist.getMatriculasActivas();
            const mat = Object.keys(matriculas)
            const recientes = await MDL.checklist.getRecientes(mat);
            Object.values(matriculas).forEach((lc) => {
                const recientes_ = (recientes ?? []).filter((r: any) => r.matricula == lc.plate && r.completado == "exito");
                if (recientes_) {
                    lc.checks = recientes_;
                } else {
                    lc.checks = [];
                }
            })
            const checklistTractoraFaltante = Object.values(matriculas).filter((lc) => (!lc.checks || lc.checks.length == 0)).length > 0;
            if (checklistTractoraFaltante) {
                SNavigation.navigate("/checklist")
            }
        } catch (e) {
            console.error("Error verificando checklist", e);
        }
    }

    render() {
        return (
            <SPage title={"Root"} hidden disableScroll>
                <SView col={"xs-12"} flex center>
                    {this.state.ready && <Mapa />}
                    <UserProfile />
                    <BottomBoxExpediciones />
                    <SView style={{ position: "absolute", top: "40%", right: 16 }} center>
                        <Recargar onFinish={async () => {
                            this.componentDidMount();
                            // SNavigation.navigate("/checklist")
                        }} />
                    </SView>
                </SView>
            </SPage>
        );
    }
}